// Sidebar.jsx
import {
  FiHome,
  FiUsers,
  FiCreditCard,
  FiPackage,
  FiChevronLeft,
  FiChevronRight,
  FiLogOut,
  FiBell,
  FiSearch,
  FiMusic,
  
} from "react-icons/fi";
import { RiDashboardHorizontalLine } from "react-icons/ri";
import { MdOutlinePermMedia } from "react-icons/md";
import { CiSettings } from "react-icons/ci";
import { FiLayers } from "react-icons/fi";

import './sidebar.css';
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Sidebar({ collapsed, setCollapsed }) {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);

  const menus = [
    {
      icon: <RiDashboardHorizontalLine size={20} />,
      title: "Dashboard",
      link: "/dashboard"
    },
    {
      icon: <FiMusic size={20} />,
      title: "Ringtones",
      link: "/ringtones"
    },
    {
      icon: <FiHome size={20} />,
      title: "Home Tabs",
      link: "/home-tabs"
    },
    {
      icon: <FiPackage size={20} />,
      title: "Plans",
      link: "/plans"
    },
    {
      icon: <FiUsers size={20} />,
      title: "Customers",
      link: '/customers'
    },
    {
      icon: <FiCreditCard size={20} />,
      title: "Payments",
      link: '/payments'
    }, 
    {
      icon: <MdOutlinePermMedia size={20} />,
      title: "Digital Media",
      link: '/digital-media'
    },
    {
      icon: <FiLayers size={20} />,
      title: "Home Screen",
      link: '/home-screen'
    },
    {
      icon: <FiPackage size={20} />,
      title: "Subscriptions",
      link: '/subscriptions'
    },
    {
      icon: <CiSettings size={20} />,
      title: "Settings",
      link: '/settings'
    },
  ];

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`sidebar-wrapper ${collapsed ? 'collapsed' : ''}`}>
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        {/* Logo Section */}
        <div className="sidebar-header">
          <div className="logo">
            {collapsed ? (
              <span className="logo-icon">D</span>
            ) : (
              <>
                <span className="logo-icon">D</span>
                <span className="logo-text">HARMIQ</span>
              </>
            )}
          </div>
          <button 
            className="toggle-btn" 
            onClick={toggleSidebar}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <FiChevronRight size={18} /> : <FiChevronLeft size={18} />}
          </button>
        </div>

        {/* Search Bar */}
        {!collapsed && (
          <div className="sidebar-search">
            <FiSearch size={16} className="search-icon" />
            <input type="text" placeholder="Search menu..." className="search-input" />
          </div>
        )}

        {/* Navigation Menu */}
        <nav className="sidebar-nav">
          <ul className="menu-list">
            {menus.map((item) => {
              const isActive = location.pathname === item.link;
              return (
                <li 
                  key={item.title} 
                  className={`menu-item ${isActive ? "active" : ""}`}
                  onMouseEnter={() => setHoveredItem(item.title)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <Link to={item.link} className="menu-link">
                    <span className="menu-icon-wrapper">
                      <span className="menu-icon">{item.icon}</span>
                      {isActive && <span className="active-dot"></span>}
                    </span>
                    {!collapsed && (
                      <span className="menu-title">{item.title}</span>
                    )}
                    {!collapsed && isActive && (
                      <span className="menu-badge">Active</span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Bottom Section */}
        <div className="sidebar-bottom">
          {/* Notifications */}
          {!collapsed && (
            <div className="sidebar-notifications">
              <FiBell size={18} />
              <span className="notification-dot"></span>
            </div>
          )}
          
          {/* User Profile */}
          <div className="sidebar-footer">
            <div className="user-info">
              <div className="user-avatar">
                <span>JD</span>
              </div>
              {!collapsed && (
                <div className="user-details">
                  <span className="user-name">John Doe</span>
                  <span className="user-role">Administrator</span>
                </div>
              )}
            </div>
            {!collapsed && (
              <button className="logout-btn" title="Logout">
                <FiLogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </aside>
    </div>
  );
}